module.exports = __webpack_public_path__ + "img/Mircosoft-Azure-Logo.fec11c9f.png";